import React, {FC} from "react";
import cn from "classnames";

import {Color, Height, Width} from "@baseTypes/baseType";

import st from "./container.module.scss";


interface Container extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode
  className?: string
  style?: React.CSSProperties
  blur?: boolean
  radius?: boolean
  shadow?: boolean
  color?: Color
  height?: Height
  width?: Width
}

const Container: FC<Container> = (props) => {
  
  const {
    className,
    style,
    children,
    blur = false,
    radius = false,
    shadow = false,
    color = Color.Ghost,
    height = Height.Full,
    width = Width.Full,
    ...rest
  } = props
  
  return (
    <div
      className={cn(
        st.container,
        color && st[`color__${color}`],
        blur && st[`color__${color}__blur`],
        st[`height__${height}`],
        st[`width__${width}`],
        radius && st.radius,
        shadow && st.shadow,
        className
      )}
      style={style}
      {...rest}
    >
      {children}
    </div>
  )
}
export default Container;